// import SearchIcon from "assets/icons/SearchIcon";
// import { SearchInput } from "components/common/Input";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import RecomendationCard from "./RecomendationCard";
import SuggestionsBlockWrapper from "components/SuggestionsBlock";
import usePersonalAI from "hooks/personalai";
import { t } from "i18next";
import Loader from "components/Loader";
import PersonalAINotFound from "../PersonalAINotFound";
import Carousel from "components/common/Carousel";

export default function Recommendations() {
  const { dir } = useAppSelector(getSettings);
  const { data, isLoading } = usePersonalAI();
  if (isLoading) return <Loader type="block" open />;

  return (
    <>
      {data.length === 0 ? (
        <PersonalAINotFound />
      ) : (
        <>
        <div className="mt-10" />
          {/* <div
            className="mt-16 mb-8 flex items-center justify-start md:justify-between max-w-[min(100vw,768px)]"
            dir={dir}
          >
            <SearchInput
              placeholder={t("search")}
              icon={<SearchIcon fill="#F29423" />}
              inputContainerClassName={
                "border-[#5A70E84F] !rounded-full w-3/4 md:w-full max-w-[min(80vw,360px)] py-3"
              }
            />
          </div> */}
          {/* <h2 className="text-2xl font-bold text-theme-blue mb-4">
            Engineering
          </h2> */}
          <Carousel
            renderItem={(item) => (
              <RecomendationCard
                key={item._id}
                title={item.major.title}
                match={item.score || 40}
                type={t("major")}
                date={item.createdAt}
                image={
                  process.env.REACT_APP_CLOUDFRONT_URL +
                  item.major.profile_images?.[0]
                }
                isLoading={!item.score}
                id={item._id}
                aiResponse={item.aiResponse}
              />
            )}
            items={data}
            options={{
              sliderBtns: true,
            }}
            navigationUI={
              <div
                className={`absolute top-0 w-16 h-full z-10 to-transparent via-50% via-[#ffffffb8] from-white ${
                  dir === "rtl"
                    ? "left-0 bg-gradient-to-r"
                    : "right-0 bg-gradient-to-l"
                }`}
              ></div>
            }
          />
        </>
      )}
      <div>
        <SuggestionsBlockWrapper />
      </div>
    </>
  );
}
